<template>
    <div class="shop_login">
        <header-section :subnav_show="false" :change_color="true"></header-section>
        <div class="shop_login_bg">
            <div class="shop_login_block">
                <div class="login_right">
                    <div class="login_block">
                        <div class="login_title">
                            <ul>
                                <li class="colors">帐号登录</li>
                            </ul>
                        </div>
                        <div class="login_input">
                            <form>
                                <div class="input_block"><el-input type="text"  v-model="info.username" placeholder="账号"></el-input></div>
                                <div class="input_block">
                                    <el-input :type="passwordflag?'text':'password'"  v-model="info.password" placeholder="密码" autocomplete="off">
                                        <span slot="suffix" @click="passwordflag = !passwordflag">
                                            <img src="@/static/img/public/open.png" v-if="passwordflag" alt="" />
                                            <img src="@/static/img/public/close.png" v-else alt="" />
                                        </span>
                                    </el-input>
                                </div>
                                <div class="input_block" style="display: flex;justify-content: flex-start;align-items: center;">
                                    <el-input v-model="info.captcha" placeholder="验证码" style="width:150px" />
                                    <img :src="captchaBase64" @click="onCaptcha" style="width: 150px;display: inline-block;margin-top:0;margin-left:5px;height:32px;cursor: pointer" />
                                </div>
                            </form>
                            
                            <!-- <div class="input_block" v-show="error_num>=5"><input v-model="info.code"  type="text" class="yzm" placeholder="短信验证码"><input @click="send_sms" class="send" type="button" value="发送验证码"></div> -->
                        </div>
                        <div class="login_btn" @click="to_login">
                            <router-link to="#">登录</router-link>
                        </div>

                        <div class="login_btn_b">
                            <router-link to="/user/register">立即注册</router-link> 
                            | <router-link to="/user/forget_password">忘记密码</router-link>
                        </div>

                        <!-- <el-divider>其他登录方式</el-divider>
                        <div class="other_login">
                            <ul>
                                <li @click="wechat_login"><i class="icon iconfont" style="color:#50b674">&#xe73b;</i></li>
                                <li><i class="icon iconfont" style="color:#06b4fd">&#xe60b;</i></li>
                            </ul>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <footer-section></footer-section>
    </div>
</template>

<script>
import HeaderSection from "@/components/public/head.vue"
import FooterSection from "@/components/public/footer.vue"
import { _local } from "@/plugins/local-storage.js"

export default {
    components: {
        HeaderSection,
        FooterSection,
    },
    props: {},
    data() {
      return {
          //login_adv:"~@/static/img/bg/bg-jobdetail.png",
          error_num:0,
          info:{
              password:'',
              captcha:'',
              username:'',
              key:''
          },
          oauth:{},
          captchaBase64:'',
          passwordflag: false
      };
    },
    watch: {},
    computed: {},
    methods: {
        onCaptcha() {
            this.$get(this.$api.useCaptchaApi,{}).then(res=>{
                this.info.key = res.data.key
                this.captchaBase64 = res.data.image
            })
        },
        // 发送短信
        send_sms:function(){
            if(this.$isEmpty(this.info.phone)){
                return this.$message.error('请先填写手机号码');
            }
            this.$post(this.$api.homeSendSms,{phone:this.info.phone,is_type:2}).then(res=>{
                if(res.code == 200){
                    return this.$message.success(res.msg);
                }else{
                    return this.$message.error(res.msg);
                }
            });
        },
        getLoginData() {
            return {
                username: this.info.username,
                password: this.info.password,
                key:this.info.key,
                captcha:this.info.captcha
            };
        },
        async to_login(){
            // this.error_num = this.get_error_num();
            if(this.$isEmpty(this.info.username) || this.$isEmpty(this.info.password)){
                return this.$message.error('账号密码不能为空');
            }
            if(!(this.info.captcha)){
                this.$message.error('请输入验证码')
                return
            }
            // this.info.username = this.info.phone;
            // if(this.error_num>=5 && this.$isEmpty(this.info.code)){
            //     return this.$message.error('请填写短信验证码');
            // }
            this.$post(this.$api.userLogin,this.getLoginData()).then(async (res)=>{
                // window.console.log(res);
                if(res.code != 0){
                    this.onCaptcha();
                    // localStorage.setItem('login_error_num',parseInt(this.error_num)+1);
                    this.$message.error(res.msg);
                }else{
                    this.$message.success('登录成功');
                    // localStorage.setItem('token',res.data.access_token);   ////
                    _local.set("token",res.data.access_token, 72*60*60*1000)
                    await this.getUserInfo();
                    // localStorage.setItem('user_info',JSON.stringify(res.data.userInfo));
                    // localStorage.removeItem('login_error_num');
                    this.$router.push('/');
                }
            }).catch(()=>{
                this.onCaptcha()
            });
        },
        async getUserInfo(){
            await this.$get(this.$api.userInfo,{}).then(res=>{
                if(res.code === 0){
                    // localStorage.setItem('user_info',JSON.stringify(res.data));   ////
                    _local.set("user_info",JSON.stringify(res.data), 72*60*60*1000)
                }
            })
        },
        // 获取本地存储登录失败次数
        get_error_num:function(){
            let error_num = localStorage.getItem('login_error_num');
            if(this.$isEmpty(error_num)){
                error_num = 0;
            }
            return error_num;
        },
        wechat_login:function(){
            location.href="https://open.weixin.qq.com/connect/qrconnect?appid="+this.oauth.appid+"&redirect_uri=%2fuser%2fwechat_login&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
        },
        // 获取配置数据
        get_oauth_config:function(){
            this.$get(this.$api.userGetOauthConfig).then(res=>{
                this.oauth = res.data;
            });
        }
        
    },
    created() {
        // this.error_num = this.get_error_num(); // 获取登录失败次数;
        this.onCaptcha()  //字母二维码请求接口
        // this.get_oauth_config();
        // console.log(localStorage.getItem('user_info'));
    },
    mounted() {
		// 监听enter事件（调用登录）
		document.onkeydown = (e) => {
			e = window.event || e;
			if (e.code === "Enter" || e.code === "enter" || e.code === "NumpadEnter") {
				this.to_login()
			}
		};
	},
	beforeDestroy() {
		document.onkeydown = null
	}
};
</script>
<style lang="scss" scoped>
.shop_login_bg{
    width: 100%;
    height: 600px;
    background: url("~@/static/img/bg/login-bg.png");
    background-size: cover;
    position: relative;
}
.shop_login_block{
    position: absolute;
    right:15vw
}
.login_left{
    float: left;
    width: 50%;
    box-sizing: border-box;
    height: 550px;
}
.login_right{
    box-sizing: border-box;
    .login_block{
        width: 400px;
        background: #fff;
        border-radius: 4px;
        box-sizing: border-box;
        padding: 30px 40px 10px;
        margin-top:80px;
        .login_title{
            margin-left: 20px;
            ul:after{
                clear:both;
                display:block;
                content:'';
            }
            ul li{
                float: left;
                margin-right: 20px;
                font-size: 20px;
                color:#444;
                
            }
            ul li.colors{
                color:#ca151e;
            }
            ul li:hover{
                color:#ca151e;
            }
            ul li:last-child{
                margin-right: 0;
            }
        }
        .login_input{
            margin-top: 30px;
            .input_block{
                margin:12px auto;
                width: 320px;
                input{
                    height: 35px;
                    width: 320px;
                    border:1px solid #e1e1e1;
                    outline:none;
                    padding:0 10px;
                    box-sizing: border-box;
                }
                .el-input.yzm{
                    width: 160px;
                    float: left;
                }
                input.send{
                    background: #333;
                    color:#fff;
                    width: 140px;
                    margin-left: 20px;
                    border: none;
                }
                /deep/ .el-input__suffix-inner{
                    line-height: 32px;
                    img{
                        vertical-align: middle;
                        cursor: pointer;
                        margin-right: 10px;
                    }
                }
            }
        }
        .login_btn{
            color:#fff;
            background: #052bfb;
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            cursor: pointer;
            margin-top: 40px;
            a{
                color:#fff;
            }
        }
        .el-divider__text{
            color:#999;
        }
        .login_btn_b{
            text-align: right;
            font-size: 12px;
            color:#666;
            line-height: 45px;
            a{
                color:#666;
            }
            a:hover{
                color:#ca151e;
            }
        }
        .other_login{
            width: 82px;
            margin:0 auto;
            ul li{
                float: left;
                margin-right: 20px;
                i{
                    font-size: 28px;
                }
            }
            ul li:last-child{
                margin-right: 0;
            }
        }
        
    }
}
  /deep/ input::-webkit-input-placeholder {
    color: #777;
  }
  /deep/ input::-moz-input-placeholder {
    color:#777;
  }
  /deep/ input::-ms-input-placeholder {
    color: #777;
  }
</style>